import script from "./PhoneNumberInput.vue?vue&type=script&setup=true&lang=js"
export * from "./PhoneNumberInput.vue?vue&type=script&setup=true&lang=js"

import "./PhoneNumberInput.vue?vue&type=style&index=0&id=14caf3bd&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-14caf3bd"]])

export default __exports__